import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import {
    addVehicleToComparison,
    sendClickSoundCommand,
    sendHoverSoundCommand,
} from 'react-wot-bootstrap'
import { VEHICLE_TO_COMPARE_TOOLTIP } from './constants'

import styles from './VehicleAddToComparison.scss'

class VehicleAddToComparison extends React.PureComponent {
    static propTypes = {
        vehicleCd: PropTypes.number.isRequired,
        isDisabled: PropTypes.bool,
        mixClassName: PropTypes.string,
    }

    handleClick = event => {
        event.preventDefault()
        event.stopPropagation()

        addVehicleToComparison(this.props.vehicleCd)
    }

    render() {
        const className = classNames(styles.base, this.props.mixClassName)

        const dataAttrs = this.props.isDisabled ? {} : {
            'data-tip': true,
            'data-for': VEHICLE_TO_COMPARE_TOOLTIP.id,
        }

        return (
            <span
                className={className}
                onClick={this.handleClick}
                onMouseDown={sendClickSoundCommand}
                onMouseEnter={sendHoverSoundCommand}
                {...dataAttrs}
            />
        )
    }
}

export default VehicleAddToComparison



// WEBPACK FOOTER //
// ./components/VehicleAddToComparison/VehicleAddToComparison.jsx